module.exports = __webpack_public_path__ + "img/tg-single-img.b0db1430.png";